import { render, staticRenderFns } from "./bannerSwiper.vue?vue&type=template&id=296df0a3&scoped=true"
import script from "./bannerSwiper.vue?vue&type=script&lang=js"
export * from "./bannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./bannerSwiper.vue?vue&type=style&index=0&id=296df0a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296df0a3",
  null
  
)

export default component.exports